import { AppBar, Button, Container, CssBaseline, Grid, LinearProgress, Toolbar, Typography } from '@mui/material'
import { blue } from '@mui/material/colors'
import withStyles from '@mui/styles/withStyles'
import _ from 'lodash'
import { withSnackbar } from 'notistack'
import React from 'react'
import { withRouter } from "react-router-dom"
import StoreCard from '../components/StoreCard'
import SocketIO from '../socketio'

const styles = (theme) => ({
    appBar: {
        backgroundColor: blue[700],
    },
    toolbar: theme.mixins.toolbar,
    cardGrid: {
        marginTop: theme.spacing(1),
    },
})

class StoreList extends React.Component {
    socket = null

    state = {
        initialized: false,
        stores: [],
    }

    async componentDidMount() {
        this.socket = new SocketIO()

        this.unbindConnect = this.socket.on('connect', this.handleConnect)
    }

    componentWillUnmount() {
        this.unbindConnect()

        this.socket.disconnect()
    }

    initialFetch = async () => {
        try {
            let { stores } = await this.socket.send('storeList', {
                domain: window.location.hostname.replace(/^[^.]+\./g, ""),
                fileset: this.props.match.params.fileset,
            })

            if (this.props.filter) {
                stores = stores.filter(this.props.filter)
            }

            await this.setState({
                initialized: true,
                stores,
            })
        } catch (err) {
            this.showError(err)
        }
    }

    handleConnect = () => {
        this.initialFetch()
    }

    showMessage = (msg, options) => {
        this.props.enqueueSnackbar(msg, {
            autoHideDuration: 3000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
            ...options,
        })
    }

    showError = (err, options) => {
        this.showMessage(err.message || err, {
            variant: 'error',
            persist: true,
            style: { whiteSpace: 'pre-line' },
            // eslint-disable-next-line react/display-name
            action: (key) => <Button onClick={() => { this.props.closeSnackbar(key) }}>Dismiss</Button>,
            ...options,
        })
    }

    closeSnackbar = this.props.closeSnackbar

    handleStoreSelect = async (store) => {
        let url = `/${this.props.match.params.fileset}/s${store.id}`

        if (this.props.urlSuffix) {
            url += this.props.urlSuffix
        }

        this.props.history.push(url) // use params to avoid trailing slash issue
    }

    render() {
        const { classes, minimalMode = false } = this.props
        const { initialized, stores } = this.state

        return (
            <>
                <CssBaseline />
                {!minimalMode && <>
                    <AppBar classes={{ root: classes.appBar }} position='absolute'>
                        <Toolbar>
                            <Typography variant="h6">Customer Gateway</Typography>
                        </Toolbar>
                    </AppBar>
                    <div className={classes.toolbar} />
                </>}
                <Container maxWidth="lg">
                    {!initialized &&
                        <Container maxWidth="xs" sx={{ py: 10 }}>
                            <LinearProgress />
                        </Container>
                    }
                    {initialized &&
                        <Grid className={classes.cardGrid} container spacing={4}>
                            {_.sortBy(stores, ['name']).map((store) =>
                                <StoreCard
                                    key={store.id}
                                    store={store}
                                    onStoreSelect={this.handleStoreSelect}
                                />
                            )}
                        </Grid>
                    }
                </Container>
            </>
        )
    }
}

export default withRouter(withSnackbar(withStyles(styles, { withTheme: true })(StoreList)))
